import { DoublyLinkedListNode } from "../../utils/doubly-linked-list";
/**
 * Abstract base for all horizontal alignment segment types.
 *
 * Extends the generic `DoublyLinkedListNode` so that `previous`, `next`,
 * and all structural / traversal helpers are inherited once and shared
 * across every concrete segment type (Linear, QuadraticBezier, ThreePointArc).
 *
 * Subclasses only need to implement the domain-specific members
 */
export class BaseHorizontalAlignmentSegment extends DoublyLinkedListNode {
    get curvePoints() {
        return this.element.points;
    }
}
//# sourceMappingURL=horizontal-alignment-base-segment.js.map